import styled, { css } from 'styled-components';

import { buttonBase, buttonSizes, buttonVariants } from '../Button/styles';

import { alertTokens } from '../../tokens/components/Alert/tokens';

export const alertBase = css`
  border-radius: ${alertTokens.ContainerBorderRadiusBaseDefault};
  border-style: ${alertTokens.ContainerBorderStyleBaseDefault};
  border-width: ${alertTokens.ContainerBorderWidthBaseDefault};
  box-shadow: ${alertTokens.ContainerShadowOffsetXBaseDefault} ${alertTokens.ContainerShadowOffsetYBaseDefault}
    ${alertTokens.ContainerShadowBlurBaseDefault} ${alertTokens.ContainerShadowSpreadBaseDefault}
    ${alertTokens.ContainerShadowColorBaseDefault};
  display: flex;
  justify-content: space-between;
  overflow-wrap: break-word;
  position: relative;
  transition-duration: 130ms;
  transition-property: opacity, transform;
  width: ${alertTokens.ContainerSizeWidthBaseDefault};
  word-break: break-word;
  padding: ${alertTokens.ContainerSpacingInnerVerticalBaseDefault}
    ${alertTokens.ContainerSpacingInnerHorizontalBaseDefault};

  &.enter {
    opacity: 0;
    transform: translateY(-10px);
  }

  &.enter-active {
    opacity: 1;
    transform: translateY(0);
  }

  &.exit {
    opacity: 1;
    transform: translateX(0);
  }

  &.exit-active {
    opacity: 0;
    transform: translateX(${alertTokens.ContainerSizeWidthBaseDefault});
  }

  // This is migrated for parity. The breakpoints are different in
  // our sass files so we'll revisit this in a different PR when
  // we add more support for responsiveness in tokens.
  @media (max-width: 766px) {
    width: 100%;
  }
`;

/* @internal */
export const AlertContentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

/* @internal */
export const AlertOrnamentWrapper = styled.div`
  margin-right: ${alertTokens.ContentSpacingOuterHorizontalBaseDefault};
`;

/* @internal */
export const AlertDismissAction = styled.button`
  display: inline-flex;
  align-items: center;
  appearance: none;
  background: none;
  border-width: 0;
  padding: 0;
  margin-left: ${alertTokens.ContentSpacingOuterHorizontalBaseDefault};

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    outline: ${alertTokens.ContainerOutlineStrokeBaseKeyboardFocus}
      ${alertTokens.ContainerOutlineColorBaseKeyboardFocus};
    outline-offset: ${alertTokens.ContainerOutlineOffsetBaseKeyboardFocus};
  }
`;

/* @internal */
export const AlertAction = styled.button`
  ${buttonBase};
  ${buttonVariants.default};
  ${buttonSizes.medium};
`;

export const alertVariants = {
  'feedback-positive': css`
    background-color: ${alertTokens.ContainerBackgroundColorPositiveDefault};
    border-color: ${alertTokens.ContainerBorderColorPositiveDefault};
  `,
  'feedback-notice': css`
    background-color: ${alertTokens.ContainerBackgroundColorNoticeDefault};
    border-color: ${alertTokens.ContainerBorderColorNoticeDefault};
  `,
  'feedback-loading': css`
    background-color: ${alertTokens.ContainerBackgroundColorPendingDefault};
    border-color: ${alertTokens.ContainerBorderColorPendingDefault};
  `,
  'feedback-negative': css`
    background-color: ${alertTokens.ContainerBackgroundColorNegativeDefault};
    border-color: ${alertTokens.ContainerBorderColorNegativeDefault};
  `,
};
